import { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Tab,
    Tabs,
} from '@mui/material';
import History from './History';
import Create from './Create';
import { unwrapNewsletterContent } from '../../utills/unwrapNewsletterContent';

const Newsletter = () => {
    const [value, setValue] = useState(0);
    const [draft, setDraft] = useState(null); // State to hold draft data

    const handleChange = (_, newValue) => {
        setValue(newValue);
        localStorage.setItem('newsletterTab', newValue); // Save only the active tab in local storage
    };

    // Handle copying newsletter data to editor
    const handleCopyToEditor = (newsletter) => {
        //unwrap the newsletter content wrapNewsletterWithTemplate
        const unwrappedContent = newsletter.content;
        setDraft({
            subject: newsletter.subject,
            content: unwrappedContent,
            recipients: newsletter.recipients,
        });
        setValue(0); // Switch to Create tab
        localStorage.setItem('newsletterTab', '0'); // Update tab in local storage
    };

    useEffect(() => {
        const savedTab = localStorage.getItem('newsletterTab');
        if (savedTab) {
            setValue(Number(savedTab));
        }
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4, px: { xs: 0.5, sm: 1 } }}>
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="inherit"
                variant="fullWidth"
                centered
                aria-label="full width tabs"
                sx={{
                    bgcolor: 'background.paper',
                    '& .MuiTab-root': {
                        textTransform: 'none',
                        fontSize: '1rem',
                    },
                }}
            >
                <Tab label="Create" />
                <Tab label="History" />
            </Tabs>

            <Box sx={{ mt: 1 }}>
                {value === 0 && <Create draft={draft} clearDraft={() => setDraft(null)} />}
                {value === 1 && <History onCopyToEditor={handleCopyToEditor} />}
            </Box>
        </Container>
    );
};

export default Newsletter;